import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { UserSession } from '../../interfaces/user-session';
import { HttpFactory } from '../../utilities/http-factory';
import { ChatResult } from '../../models/net/result/chat-result';
import { TextSubscription } from '../../models/data/app-core/text-subscription';
import { TextSubscriptionRegistrationResult } from '../../models/net/result/text-subscription-registration-result';

@Injectable({
    providedIn: 'root'
})

export class ChatService {

    public _apiBaseUrl: string = "";

    public constructor(private http: HttpClient, @Inject("API_BASE_URL") apiBaseUrl: string) {

        this._apiBaseUrl = apiBaseUrl;
    }

    public ask = (question: string): Observable<ChatResult | null> => {

        const result = HttpFactory.get<ChatResult>(this.http, "chat/ask/" + question, this._apiBaseUrl);

        return result;
    }

    public registerTextSubscription = (textSubscription: TextSubscription): Observable<TextSubscriptionRegistrationResult | null> => {

        const result = HttpFactory.anonPost<TextSubscriptionRegistrationResult>(this.http, textSubscription, "chat/registertextsubscription", this._apiBaseUrl);

        return result;
    }
}
